export default {
  "removeItem": "Quitar artículo",
  "addItem": "Añadir artículo",
  "invalidClubCodeForInRoomScreenRoute": "Código de club no válido para la pantalla de habitación",
  "screenNotProvisionedMissingClubCodeDeviceCode": "Pantalla sin configurar o sin identificación del club o dispositivo",
  "screenNotFound": "Pantalla no encontrada",
  "unableToStartProvisioning": "No se pudo iniciar la configuración",
  "waitingForProvisioning": "Esperando la configuración...",
  "memberMode": "Modo socio",
  "yourPrivateSanctuary": "Tu refugio privado",
  "communication": "Comunicación",
  "bookings": "Reservas",
  "diningDrinks": "Comida y bebida",
  "activities": "Actividades",
  "roomService": "Servicio de habitaciones",
  "message": "Mensajes",
  "contactConciergeStaff": "Contacta con conserjería y el personal",
  "reservations": "Reservas",
  "viewAndAdjustUpcomingBookings": "Consulta y modifica tus próximas reservas",
  "orderDrinks": "Pedir bebidas",
  "seeOurMenus": "Consulta nuestras cartas",
  "planActivities": "Planifica actividades",
  "exploreOurAmenities": "Descubre nuestras instalaciones",
  "callFrontDesk": "Llamar a recepción",
  "golfTeeTimes": "Salidas de golf",
  "spaRitual": "Ritual de spa",
  "fitnessSession": "Sesión de fitness",
  "racquetCourt": "Pista de raqueta",
  "dining": "Restauración",
  "signatureCocktails": "Cócteles de autor",
  "wineList": "Carta de vinos",
  "inRoomDining": "Comer en la habitación",
  "eventsCalendar": "Calendario de eventos",
  "guidedTours": "Visitas guiadas",
  "wellnessSchedule": "Programa de bienestar",
  "localHighlights": "Lugares de interés",
  "breakfast": "Desayuno",
  "lateNightBites": "Tentempiés nocturnos",
  "housekeepingRequest": "Solicitar limpieza",
  "welcomeBack": "Te damos la bienvenida de nuevo",
  "welcome": "Te damos la bienvenida",
  "messageFrontDesk": "Enviar mensaje a recepción",
  "missingClub": "Falta el club",
  "unableToPlaceTheCall": "No se pudo realizar la llamada.",
  "roomUnavailable": "Habitación no disponible",
  "noRoomIsAssignedToThisScreen": "Esta pantalla no tiene una habitación asignada.",
  "frontDeskCallingIsntConfiguredYet": "Las llamadas a recepción aún no están configuradas.",
  "unableToPlaceCall": "No se pudo realizar la llamada",
  "pleaseTryAgainSoon": "Inténtalo de nuevo pronto.",
  "callingFrontDesk": "Llamando a recepción…",
  "connectingYourRequest": "Conectando tu solicitud.",
  "unableToHangUp": "No se pudo colgar",
  "pleaseTryAgain": "Inténtalo de nuevo.",
  "messageFailed": "No se pudo enviar el mensaje",
  "item": "Artículo",
  "orderPlaced": "Pedido realizado · #",
  "roomServiceHasReceivedYourRequest": "El servicio de habitaciones ha recibido tu solicitud.",
  "pleaseReviewYourOrderAndTryAgain": "Revisa tu pedido e inténtalo de nuevo.",
  "menuIsNoLongerAvailable": "La carta ya no está disponible.",
  "orderRetryConflictPleaseTryAgain": "No se pudo reintentar el pedido. Inténtalo de nuevo.",
  "unableToPlaceOrder": "No se pudo realizar el pedido",
  "pleaseTryAgainInAMoment": "Inténtalo de nuevo en un momento.",
  "room": "Habitación",
  "deviceDisabled": "Dispositivo desactivado",
  "thisScreenIsDisabledAskStaffToEnableItInTheClubPortal": "Esta pantalla está desactivada. Pide al personal que la active en el portal del club.",
  "screenAlreadyPaired": "Pantalla ya vinculada",
  "thisScreenIsAlreadyPairedToClub": "Esta pantalla ya está vinculada al club",
  "device": ", dispositivo",
  "openInRoomScreen": "Abrir pantalla de habitación",
  "pairAnotherScreen": "Vincular otra pantalla",
  "screenProvisioning": "Configuración de pantalla",
  "installID": "ID de instalación:",
  "shareThisCodeWithClubStaffToClaimThisScreen": "Comparte este código con el personal para registrar la pantalla.",
  "expiresIn": "Caduca en",
  "staffInstructions": "Instrucciones para el personal",
  "openTheClubPortalRoomsInRoomScreens": "Abre el portal del club > Habitaciones > Pantallas de habitación.",
  "clickAddScreenAndEnterThisCode": "Pulsa «Añadir pantalla» e introduce este código.",
  "selectTheRoomToAssignAndSubmit": "Selecciona la habitación y confirma la asignación.",
  "status": "Estado:",
  "waitingForAClubAdminToClaimThisScreenTheDisplayWillAutomaticallyContinueOnceAssigned": "Esperando a que un administrador registre esta pantalla. Continuará automáticamente tras la asignación.",
  "suiteBackdrop": "Fondo de la suite",
  "privacy": "Privacidad",
  "home": "Inicio",
  "wellNotifyYouWhenItsReady": "Te avisaremos cuando esté listo.",
  "memberPortal": "Portal de socios",
  "bookingsMessagingAndSchedulesStayAvailable": "Las reservas, los mensajes y los horarios siguen disponibles.",
  "backToHome": "Volver al inicio",
  "signOutOnThisScreen": "Cerrar sesión en esta pantalla",
  "memberPortalModulesRenderHereInProductionThisPlaceholderKeepsTheLayoutConsistentWhileThePairingSessionIsActive": "Los módulos del portal de socios se muestran aquí en producción. Este espacio conserva el diseño mientras la vinculación está activa.",
  "bookingShortcuts": "Accesos a reservas",
  "messagesConcierge": "Mensajes y conserjería",
  "liveChatWithTheFrontDeskTeam": "Chat en directo con el equipo de recepción.",
  "back": "Volver",
  "typeYourMessage": "Escribe tu mensaje…",
  "send": "Enviar",
  "refinedOptionsCuratedForYourStay": "Opciones seleccionadas para tu estancia.",
  "inCallWithFrontDesk": "En llamada con recepción",
  "callEnded": "Llamada finalizada",
  "tapToContinue": "Pulsa para continuar",
  "enter": "Entrar",
  "hangUp": "Colgar",
  "confirmRoomServiceOrder": "Confirmar pedido a la habitación",
  "reviewYourItemsBeforePlacingTheOrder": "Revisa los artículos antes de realizar el pedido.",
  "subtotal": "Subtotal",
  "deliveryFee": "Gastos de entrega",
  "total": "Total",
  "cancel": "Cancelar",
  "placingOrder": "Realizando pedido…",
  "confirmOrder": "Confirmar pedido",
  "pairDevice": "Vincular dispositivo",
  "syncWithYourPhone": "Sincronizar con tu teléfono",
  "pairingCode": "Código de vinculación",
  "menus": "Cartas",
  "loadingMenus": "Cargando cartas…",
  "noRoomServiceMenusAvailable": "No hay cartas disponibles para el servicio de habitaciones.",
  "items": "Artículos",
  "loadingItems": "Cargando artículos…",
  "basket": "Cesta",
  "noItemsYet": "Aún no hay artículos.",
  "placeOrder": "Realizar pedido",
  "loading": "cargando...",
  "requested": "Solicitado",
  "confirmed": "Confirmado",
  "preparing": "En preparación",
  "ready": "Listo",
  "delivered": "Entregado",
  "cancelled": "Cancelado"
};
